import { get } from "lodash";
import React, { FC, Fragment } from "react";
import { Identifiers } from "~/constants/enum";
import useCmsBlocks from "~/hooks/useCmsBlocks";
import { styles as TextStyles } from "~/components/Text";
import { replaceClassNames } from "~/utils/converters";
import Container from "~/components/Container";

interface BundleBannerProps {
  data?: any;
}

const BundleBanner: FC<BundleBannerProps> = ({ data }) => {
  const { cmsBlocks } = useCmsBlocks([Identifiers.BundleBanner]);
  const content = data
    ? get(data, "content", null)
    : get(cmsBlocks, [Identifiers.BundleBanner, "content"], null);

  const compileStyle = {
    Text: TextStyles,
  };

  return content ? (
    <Container>
      <div
        dangerouslySetInnerHTML={{
          __html: replaceClassNames(content ?? "", compileStyle),
        }}
      />
    </Container>
  ) : (
    <></>
  );
};

export default BundleBanner;
